export const Logo = () => {
    return <img src="/images/Logo_5-transformed.png" alt="logo" width={150} />;
};
